import { graphql } from '../../generated';

export const GET_STAT_PRODUCT_VARIANTS = graphql(`
  query getStatsProductVariants(
    $first: Int
    $after: String
    $terms: [String!]
    $productStatuses: [ProductStatus!]
    $onlyActive: Boolean
    $startDate: ISO8601DateTime
    $endDate: ISO8601DateTime
    $productCategoryIds: [ID!]
    $skuList: [String!]
  ) {
    productVariants(
      first: $first
      after: $after
      productType: MERCH_PRODUCT
      terms: $terms
      productStatuses: $productStatuses
      onlyActive: $onlyActive
      productCategoryIds: $productCategoryIds
      skuList: $skuList
    ) {
      pageInfo {
        startCursor
        hasPreviousPage
        hasNextPage
        endCursor
      }
      edges {
        node {
          product {
            id
            name
            slug
            artist
            ... on MerchProduct {
              color
              productType
            }
          }
          id
          description
          ean
          sku
          statistics(startDate: $startDate, endDate: $endDate) {
            initialStock
            incomingStock
            outgoingStock
            lostStock
            soldDelivered
            sentIncomplete
            refundDelivered
            clearingStock
            closingStock
            sold
            refund
            soldUnfulfilled
            reserved
            availableStock
            netSold
          }
        }
      }
    }
  }
`);
